<template>
  <section class="space-y-4 px-4">
    <div
      class="bg-background-neutral-secondary flex flex-col items-center justify-center space-y-4 rounded-2xl p-4"
    >
      <img
        src="../../../assets/images/no-saved-passengers.svg"
        alt=""
        width="140"
        height="200"
      />
      <div class="text-center">
        <h3 class="text-text-neutral-primary text-base font-semibold">
          {{ t('savedPassengers.noSavedPassengers') }}
        </h3>
        <p class="text-text-neutral-quaternary text-sm">
          {{ t('savedPassengers.autoSaveAfterBooking') }}
        </p>
      </div>
    </div>
    <FreeButton
      v-if="!withoutAction"
      type="button"
      class="green-main-button w-full p-4"
      @click="$emit('onCloseBottomSheet')"
    >
      {{ t('savedPassengers.enterPassengerManuallyButton') }}
    </FreeButton>
  </section>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import { FreeButton } from '../../../shared/ui';

  defineProps<{
    withoutAction?: boolean;
  }>();

  defineEmits<{
    onCloseBottomSheet: [];
  }>();

  const { t } = useI18n();
</script>

<i18n src="../locales.json"></i18n>
